import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { ConsorcioService, MenuFuncionService, PaisService, MedioPagoService, ProvinciaService, TipoDocumentoService, TipoResponsableIvaService, TenantService, MonedaService, BancoService, CuentaService, MovimientoService } from '../../../../src/app/shared/services';
import { Banco, Consorcio, Cuenta, DialogConfirmRequest, DialogConfirmResponse, MedioPago, LocalStorageKeys, MenuFuncionCodes, Moneda, Pais, Provincia, SaveConsorcioDto, SearchBancoRequest, SearchCuentaRequest, SearchMedioPagoRequest, SearchMonedaRequest, SearchPaisRequest, SearchProvinciaRequest, SearchTipoDocumentoRequest, TenantFeatureFlags, GetSaldoRequestDto, GetSaldoMonedaDto } from '../../../../src/app/shared/model';
import { SearchTipoResponsableIvaRequest, TipoDocumento, TipoResponsableIva, MetodoRedondeoExpensa, ConceptosRecargo } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-consorcioEdit',
  templateUrl: './consorcioEdit.component.html',
  styles: [ ]
})

export class ConsorcioEditComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;
  @ViewChild('cuentasGrid')
  public cuentasGrid: GridComponent;

  formGroup: FormGroup;
  medioPagoFormGroup: FormGroup;
  cuentaBancariaFormGroup: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoSearching: boolean = false;
  isRolTipoSearching: boolean = false;

  canView: boolean = false;
  canAdd: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  canEditCuenta: boolean = false;
  canDeleteCuenta: boolean = false;
  canAddCuenta: boolean = false;
  canViewCuenta: boolean = false;
  canViewSaldos: boolean = false;

  isTipoDocumentoSearching: boolean = false;
  isProvinciaSearching: boolean = false;
  isPaisSearching: boolean = false;
  isTipoResponsableIvaSearching: boolean = false;
  isConceptosRecargoSearching: boolean = false;
  isMetodosRedondeoExpensaSearching: boolean = false;
  isMediosPagoSearching: boolean = false;
  isMedioPagoSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isBancoSearching: boolean = false;
  isCuentasSearching: boolean = false;
  isSaldosSearching: boolean = false;

  tenantFeatureFlags: TenantFeatureFlags;

  msgError: string = "";
  item: Consorcio;
  tiposdocumentosString: string = "";
  provinciasString: string = "";
  paisesString: string = "";
  tiposResponsablesIvaString: string = "";

  monedaList: Moneda[] = [];
  bancoList: Banco[] = [];
  tipoDocumentoList: TipoDocumento[];
  provinciaList: Provincia[];
  paisList: Pais[];
  tipoResponsableIvaList: TipoResponsableIva[];
  conceptosRecargoList: ConceptosRecargo[];
  metodosRedondeoExpensaList: MetodoRedondeoExpensa[];
  medioPagoList: MedioPago[];
  saldosList: GetSaldoMonedaDto[];

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private tipoDocumentoService: TipoDocumentoService,
    private provinciaService: ProvinciaService,
    private paisService: PaisService,
    private tipoResponsableIvaService: TipoResponsableIvaService,
    private consorcioService: ConsorcioService,
    private monedaService: MonedaService,
    private bancoService: BancoService,
    private cuentaService: CuentaService,
    private medioPagoService: MedioPagoService,
    private movimientoService: MovimientoService,
    private tenantService: TenantService
    ) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.CONSORCIO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.CONSORCIO_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.CONSORCIO_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.CONSORCIO_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.CONSORCIO_DELETE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.buildMedioPagoForm();
    this.buildCuentaForm();

    this.puedeVerCuentas();
    this.puedeVerSaldos();

    this.getTipoDocumento();
    this.getPaises();
    this.getTipoResponsableIva();
    this.getConceptosRecargo();
    this.getMetodosRedondeoExpensa();
    this.getMedioPago();

    this.getBancos();
    this.getMonedas();

    this.loadEntity();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(200)]],
      'RazonSocial': [null, [Validators.required, Validators.maxLength(200)]],
      'TipoDocumentoId': [null, Validators.required],
      'NroDocumento': [null, [Validators.required, Validators.maxLength(50)]],
      'ProvinciaId': [null],
      'PaisId': [null],
      'Direccion': [null, Validators.maxLength(200)],
      'CodigoPostal': [null, Validators.maxLength(50)],
      'Telefono': [null, Validators.maxLength(100)],
      'Email': [null, [Validators.maxLength(255), Validators.email]],
      'TipoResponsableIvaId': [null],
      'ValidarUfTotalPorcentaje': [false],
      'InteresVencimiento': [null],
      'InteresMensual': [null],
      'ConceptosRecargo': [null],
      'MetodoRedondeoExpensa': [null],
      'NotaExpensas': [null, Validators.maxLength(1000)],
      'NotaExpensasPie': [null, Validators.maxLength(1000)],
      'Activo': [true, Validators.required]
    });
  }

  buildMedioPagoForm() {
    this.medioPagoFormGroup = this.formBuilder.group({
      'Id': [0],
      'MedioPago': [null, [Validators.required]],
      'Titular': [null, Validators.maxLength(100)],
      'Cuit': [null, Validators.maxLength(100)],
      'Banco': [null],
      'CodigoUnico': [null, Validators.maxLength(100)],
      'Alias': [null, Validators.maxLength(100)],
      'NumeroCuenta': [null, Validators.maxLength(100)],
      'grid-index': [null]
    });
  }

  buildCuentaForm() {
    this.cuentaBancariaFormGroup = this.formBuilder.group({
      'Id': [0],
      'BancoId': [null, Validators.required],
      'MonedaId': [null, Validators.required],
      'ClaveBancaria': [null, [Validators.required, Validators.maxLength(100)]],
      'Alias': [null, [Validators.required, Validators.maxLength(100)]],
      'Titular': [null, [Validators.maxLength(100)]],
      'NumeroCuenta': [null, [Validators.maxLength(100)]],
      'Activo': [true],
      'grid-index': [null]
    });
  }

  puedeVerCuentas() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.CUENTA).subscribe(data => {
      if (data != null && data.Success && data.Result != null)
        this.canEditCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_EDIT);
        this.canAddCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_ADD);
        this.canViewCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_LIST);
        this.canDeleteCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_DELETE);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerSaldos() {
    if (!this.tenantFeatureFlags?.HabilitarControlCaja) {
      this.canViewSaldos = false;
      return false;
    }

    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewSaldos = this.canViewSaldos || (data?.Result != null && data?.Result.length > 0);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  getTipoDocumento() {
     var r = new SearchTipoDocumentoRequest(null, null, true, "Nombre", null, null, true);
     this.isTipoDocumentoSearching = true;

     this.tipoDocumentoService.search(r).subscribe(data => {
       this.isTipoDocumentoSearching = false;
       if (data != null) {
         this.tipoDocumentoList = data?.result;
         this.formGroup.get("TipoDocumentoId")?.setValue(this.tipoDocumentoList.find(f => f.Nombre == "CUIT")?.Id);
       }
     },
     (err: HttpErrorResponse) => {
       this.isTipoDocumentoSearching = false;
       this.sharedFunctions.handleError(err);
     });
  }

  getCuentas(id: number) {
    var r = new SearchCuentaRequest(null, null, true, "Alias", null, null, null, null, null, null, null, null, null, id, null, null, true, null, null, null);
    this.isCuentasSearching = true;

    this.cuentaService.search(r).subscribe(data => {
      this.isCuentasSearching = false;
      // console.log(data);
      if (this.item != null)
        this.item.Cuentas = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isCuentasSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getSaldos(id) {
    var r = new GetSaldoRequestDto(null, id, null, null, null, null, null);
    this.isSaldosSearching = true;
    
    this.movimientoService.getSaldo(r).subscribe(data => {
      this.isSaldosSearching = false;
      if (data?.Success)
        this.saldosList = data.Result?.Saldos;
    },
    (err: HttpErrorResponse) => {
      this.isSaldosSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getPaises() {
    var r = new SearchPaisRequest(null, null, true, "Nombre", null, null, true);
    this.isPaisSearching = true;

    this.paisService.search(r).subscribe(data => {
      this.isPaisSearching = false;
      if (data != null)
        this.paisList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isPaisSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getBancos() {
    if (!this.tenantFeatureFlags.HabilitarControlCaja)
      return false;

    this.bancoService.search(new SearchBancoRequest(null,null,null,null,null,null,null,true)).subscribe(data => {
      this.isBancoSearching = true;
      if (data != null && data.result) {
        this.isBancoSearching = false;
        this.bancoList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isBancoSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getMonedas() {
    if (!this.tenantFeatureFlags.HabilitarControlCaja)
      return false;

    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
        this.isMonedaSearching = false;
        this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
        this.isMonedaSearching = false;
        this.sharedFunctions.handleError(err);
    });
  } 

  getConceptosRecargo() {
    this.isConceptosRecargoSearching = true;
    this.consorcioService.getConceptosRecargo().subscribe(data => {
      this.isConceptosRecargoSearching = false;
      if (data != null)
        this.conceptosRecargoList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isConceptosRecargoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMetodosRedondeoExpensa() {
    this.isMetodosRedondeoExpensaSearching = true;
    this.consorcioService.getMetodosRedondeoExpensa().subscribe(data => {
      this.isMetodosRedondeoExpensaSearching = false;
      if (data != null)
        this.metodosRedondeoExpensaList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isMetodosRedondeoExpensaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTipoResponsableIva() {
    var r = new SearchTipoResponsableIvaRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoResponsableIvaSearching = true;

    this.tipoResponsableIvaService.search(r).subscribe(data => {
      this.isTipoResponsableIvaSearching = false;
      if (data != null)
        this.tipoResponsableIvaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoResponsableIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMedioPago() {
    this.isMedioPagoSearching = true;
    this.medioPagoService.search(new SearchMedioPagoRequest(null,null,null,null,null,null,true)).subscribe(data=> {
      this.isMedioPagoSearching = false;
      this.medioPagoList = data?.result;
    },
    (err: HttpErrorResponse)=> {
      this.isMedioPagoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
          if(this.canView || this.canEdit) {
            this.isSearching = true;
            this.consorcioService.get(id).subscribe(data => {
              this.isSearching = false;
              if (data != null && data.Success) {
                this.item = data.Result;

                if (this.item != null && this.item.Id > 0) {
                  this.loadMediosPago(this.item.Id);
                  this.getCuentas(this.item.Id);
                  this.getSaldos(this.item.Id);

                  if (this.canEdit)
                    this.formGroup.patchValue(this.item);
                    this.onPaisSelect();
                }
                else
                  this.msgError = "No se encontró el item seleccionado.";
              }
              else
                this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
            },
            (err: HttpErrorResponse) => {
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.item = new Consorcio(0, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true, 0, [], []);
          this.formGroup.patchValue(this.item);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel(); 
        }
      }
    });
  }

  loadMediosPago(id) {
    this.isMediosPagoSearching = true;
    this.consorcioService.getMediosPago(id).subscribe(data => {
      this.isMediosPagoSearching = false;
      this.item.MediosPago = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isMediosPagoSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onPaisSelect() {
    var pId: number | null = null;
    if (this.canEdit)
      pId = this.formGroup.get("PaisId")?.value;
    else
      pId = this.item.PaisId;

    if (pId != null && pId > 0) {
      var r = new SearchProvinciaRequest(null, null, true, "Nombre", null, null, pId, true);
      this.isProvinciaSearching = true;

      this.provinciaService.search(r).subscribe(data => {
        this.isProvinciaSearching = false;
        if (data != null)
          this.provinciaList = data?.result;
      },
      (err: HttpErrorResponse) => {
        this.isProvinciaSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
    else
      this.provinciaList = [];
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getErrorRazonSocial() {
    var v = this.formGroup.get('RazonSocial');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getErrorTipoDocumento() {
    return this.formGroup.get('TipoDocumentoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNroDocumento() {
    var v = this.formGroup.get('NroDocumento');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 50 caracteres alcanzado';
    return '';
  }

  getErrorDireccion() {
    var v = this.formGroup.get('Direccion');
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getErrorCodigoPostal() {
    var v = this.formGroup.get('CodigoPostal');
    if (v?.hasError('maxlength'))
      return 'Límite de 50 caracteres alcanzado';
    return '';
  }

  getErrorTelefono() {
    var v = this.formGroup.get('Telefono');
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    return '';
  }

  getErrorMail() {
    var v = this.formGroup.get('Email');
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getNotaExpensas() {
    var v = this.formGroup.get('NotaExpensas');
    if (v?.hasError('maxlength'))
      return 'Límite de 1000 caracteres alcanzado';
    return '';
  }

  getNotaExpensasPie() {
    var v = this.formGroup.get('NotaExpensasPie');
    if (v?.hasError('maxlength'))
      return 'Límite de 1000 caracteres alcanzado';
    return '';
  }

  onMedioPagoAdd() {
    if (!this.medioPagoFormGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    if (this.item.MediosPago == null)
      this.item.MediosPago = [];

    var id = this.medioPagoFormGroup.get("Id")?.value;

    var index = -1;
    if (id != null && id > 0)
      index = this.item.MediosPago.findIndex(f => f.Id == id);
    else
      index = (this.medioPagoFormGroup.get("grid-index")?.value ?? -1);

    if (index >= 0)
      this.item.MediosPago[index] = this.medioPagoFormGroup.getRawValue();
    else {
      this.item.MediosPago.push(this.medioPagoFormGroup.getRawValue());
      index = this.item.MediosPago.length - 1;
    }

    this.item.MediosPago[index].MedioPagoId = this.medioPagoFormGroup?.get("MedioPago")?.value?.Id;
    this.item.MediosPago[index].MedioPagoNombre = this.medioPagoFormGroup?.get("MedioPago")?.value?.Nombre;

    this.item.MediosPago[index].BancoId = this.medioPagoFormGroup?.get("Banco")?.value?.Id;
    this.item.MediosPago[index].BancoNombre = this.medioPagoFormGroup?.get("Banco")?.value?.Nombre;

    this.onMedioPagoClean();
  }

  getErrorMedioPago() {
    var v = this.medioPagoFormGroup.get('MedioPago');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorTitular() {
    var v = this.medioPagoFormGroup.get('Titular');
    // if (v?.hasError('required'))
    //   return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorCuit() {
    var v = this.medioPagoFormGroup.get('Cuit');
    // if (v?.hasError('required'))
    //   return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorBanco() {
    var v = this.medioPagoFormGroup.get('BancoId');
    // if (v?.hasError('required'))
    //   return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorCodigoUnico() {
    var v = this.medioPagoFormGroup.get('CodigoUnico');
    // if (v?.hasError('required'))
    //   return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorAlias() {
    var v = this.medioPagoFormGroup.get('Alias');
    // if (v?.hasError('required'))
    //   return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNumeroCuenta() {
    var v = this.medioPagoFormGroup.get('NumeroCuenta');
    // if (v?.hasError('required'))
    //   return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  onMedioPagoClean() {
    this.grid.refresh();
    this.buildMedioPagoForm();
  }

  onMedioPagoView(item: any) {
    if (item != null && item.index >= 0) {
      if (this.canAdd || this.canEdit) {
        this.medioPagoFormGroup.patchValue(item);

        var fpResult = this.medioPagoList?.filter(f => f.Id == item.MedioPagoId);
        if (fpResult != null && fpResult.length > 0)
          this.medioPagoFormGroup.get("MedioPago")?.setValue(fpResult[0]);

        var bResult = this.bancoList?.filter(f => f.Id == item.BancoId);
        if (bResult != null && bResult.length > 0)
          this.medioPagoFormGroup.get("Banco")?.setValue(bResult[0]);

        this.medioPagoFormGroup.get("grid-index")?.setValue(item.index);
      }
    }
  }

  onMedioPagoDelete(item: any) {
    if (item != null && item.index >= 0) {
      if (this.item.MediosPago == null)
        this.item.MediosPago = [];

      this.item.MediosPago.splice(item.index, 1);
      this.grid.refresh();
    }
  }

  onCuentaSave() {
    if (this.cuentaBancariaFormGroup.invalid) {  
      this.sharedFunctions.showMessage("Formulario inválido. Por favor, complete todos los campos requeridos.", "Error");       
      return;
    }
    
    var nuevaCuenta = new Cuenta(0, null, false, null, null, null, null, null, null, null, null, true, null, null, null, null, null, null, null, null, null, null); 
    nuevaCuenta = { 
      ...this.cuentaBancariaFormGroup.getRawValue(),
      BancoNombre: this.bancoList.find(x => x.Id == this.cuentaBancariaFormGroup.get("BancoId")?.value)?.Nombre, 
      MonedaCodigo: this.monedaList.find(x => x.Id == this.cuentaBancariaFormGroup.get("MonedaId")?.value)?.Codigo, 
      ProveedorId: (this.item?.Id ?? 0)
    };

    // console.log(nuevaCuenta);

    if (this.item.Cuentas == null)
      this.item.Cuentas = [];

    var index = this.cuentaBancariaFormGroup.get("grid-index")?.value;
    // console.log(index);
    if (index != null && index >= 0) {
      // console.log("lala");
      this.item.Cuentas[index] = nuevaCuenta;
    }
    else {
      // console.log("adsdsa");
      var exists = this.item.Cuentas.some(f => f.Alias == nuevaCuenta.Alias || f.ClaveBancaria == nuevaCuenta.ClaveBancaria);
      if (exists) {
        this.sharedFunctions.showMessage("El alias o CBU/CVU ingresados ya existen para el proveedor", "Error");
        return false;
      }

      this.item.Cuentas.push(nuevaCuenta);
    }

    this.cuentaBancariaFormGroup.reset();
    this.cuentaBancariaFormGroup.controls['Id'].setValue(0);
    this.cuentaBancariaFormGroup.controls['Activo'].setValue(true);
    
    // console.log(this.item.Cuentas);
    this.cuentasGrid?.refresh();
  }

  onCuentaView(data: any) {
    this.cuentaBancariaFormGroup.patchValue(data);
    this.cuentaBancariaFormGroup.get("grid-index")?.setValue(data.index);
  }

  onCuentaDelete(data: any) {
    if (this.item.Cuentas == null)
      this.item.Cuentas = [];

    if (data.index >= 0) {
      this.item.Cuentas.splice(data.index, 1);
      this.cuentasGrid?.refresh();
    }
  }

  getCuentaErrorClaveBancaria() {
    var v = this.cuentaBancariaFormGroup.get('ClaveBancaria');
    if (v?.hasError('required'))
        return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getCuentaErrorNumeroCuenta() {
    var v = this.cuentaBancariaFormGroup.get('NumeroCuenta');
    // if (v?.hasError('required'))
    //     return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getCuentaErrorTitular() {
    var v = this.cuentaBancariaFormGroup.get('Titular');
    // if (v?.hasError('required'))
    //     return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getCuentaErrorAlias() {
    var v = this.cuentaBancariaFormGroup.get('Alias');
    if (v?.hasError('required'))
        return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
        return 'Límite de 100 caracteres alcanzado';
    return '';
  }
  
  getCuentaErrorBanco() {
    var v = this.cuentaBancariaFormGroup.get('BancoId');
    // if (v?.hasError('required'))
    //     return 'El campo es obligatorio';
    return '';
  }

  getCuentaErrorMoneda() {
    var v = this.cuentaBancariaFormGroup.get('MonedaId');
    if (v?.hasError('required'))
        return 'El campo es obligatorio';
    return '';
  }

  onGuardar() {

    if (!this.formGroup.valid) {

      var tdId = this.formGroup.get("TipoDocumentoId")?.value;
      if (tdId == null || tdId <= 0) {
        this.getErrorTipoDocumento();
        this.sharedFunctions.showMessage("Por favor complete el tipo de documento para continuar", "Error");
      }
      else
        this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");

      return false;
    }

    if (this.tenantFeatureFlags != null && this.tenantFeatureFlags.HabilitarControlExpensas) {
      var intMen = this.formGroup.get("InteresMensual")?.value;
      if (intMen == null || intMen < 0 || intMen > 100) {
        this.sharedFunctions.showMessage("Debe ingresar un interés mensual válido para continuar", "Error");
        return false;
      }

      var intVen = this.formGroup.get("InteresVencimiento")?.value;
      if (intVen == null || intVen < 0 || intVen > 100) {
        this.sharedFunctions.showMessage("Debe ingresar un interés vencimiento válido para continuar", "Error");
        return false;
      }
      
      var mre = this.formGroup.get("MetodoRedondeoExpensa")?.value;
      if (mre == null || mre <= 0) {
        this.sharedFunctions.showMessage("Debe seleccionar un méetodo de redondeo de expensa para continuar", "Error");
        return false;
      }

      var cr = this.formGroup.get("ConceptosRecargo")?.value;
      if (cr == null || cr <= 0) {
        this.sharedFunctions.showMessage("Debe seleccionar un concepto de recargo para continuar", "Error");
        return false;
      }
    }

    var r = new SaveConsorcioDto(0, null, null,null, 0, 0, 0, null, null, null, null, 0, 0, 0, 0, 0, null, null, true, []);

    r = {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        Activo: this.item.Activo,
        MediosPago: this.item.MediosPago,
        Cuentas: this.item.Cuentas
      }
    };

    this.isSaving = true;
    this.consorcioService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDelete() {
    if (!this.canDelete) 
        return false;
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el consorcio?", null, null)
    });
    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
            this.isDeleting = true;
            this.consorcioService.delete(this.item.Id).subscribe(data => {
                this.isDeleting = false;
                if (data != null && data.Success && data.Result) {
                    this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
                    this.onCancel();
                }
                else
                    this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
            },
            (err: HttpErrorResponse) => {
                this.isDeleting = false;
                this.sharedFunctions.handleError(err, true);
            })
        }
    });
  }

  onCancel() {
    this.location.back();
  }
}